<template>
  <v-footer
    v-if="!hideFooter"
    app
    dark
    height="auto"
    class="pa-0"
    >
    <v-card
      class="flex"
      flat
      tile
      >
      <v-card-actions :class="appColor_Footer + ' justify-center'">
        &copy;2025 —&nbsp;<strong>Cattlytics</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
import { AppColor } from '@/config.js'

export default {
  name: 'AppFooter',
  data () {
    return {
      appColor_Footer: AppColor.Footer
    }
  },
  computed: {
    hideFooter () {
      return (this.$route.name === 'Logout')
    }
  }
}
</script>
